import { HttpErrorResponse } from '@angular/common/http';
import { EmptyError, throwError } from 'rxjs';

export function handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
    } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
            `Backend returned code ${error.status}, ` +
            `body was:`);
        console.error(error.error);
    }

    // return an observable with a user-facing error message
    let errorObj;
    if (error?.error?.message) {
        errorObj = { message: error.error.message };
    } else if (error.error) {
        errorObj = Object.assign({ status: error.status }, error.error);
    } else {
        errorObj = error; // 'Something bad happened; please try again later.';
    }

    if (error instanceof HttpErrorResponse && error.status === 404) {
        return throwError(() => ({
            status: 404,
            error: errorObj
        }));
    } else if (error instanceof HttpErrorResponse && error.status === 401) {
        return throwError(() => ({
            status: 401,
            error: errorObj
        }));
    }

    // return an observable with a user-facing error message
    return throwError(() => errorObj);
}

export function isEmptyError(error: any): boolean {
    return error?.name === 'EmptyError' || error instanceof EmptyError;
}       